import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
// import { useFormik } from 'formik';

//functional Import 
import { showToast } from "../../../utils/constants/Toaster";
import { userDetailsApi,UpdateUserApi,GetCityList} from "../../../services/apiServices/PostServices";
import { ShareValueDetials,getStateList,getBankList} from "../../../services/apiServices/GetServices";
import CustomTextField from "../../../utils/resuableComponents/CustomTextfield";
import { CustomDropdown } from "../../../utils/resuableComponents/CustomDropdown";
import Loader from "../../loadingScreens/Loader";
import { getData } from "../../../utils/AsyncStorage";
import Modal from 'react-bootstrap/Modal'
import { useForm } from "react-hook-form";
import { Formik, useFormik } from 'formik';

const EditUserDetails = (props) => {
    const {modalOpen,userdetails,modalClose} = props
    const { role, first_name,last_name,id } = JSON.parse(getData("userInfo") || 0);
    const [stateId, setStateId] = useState("")
    const [email, setEmail] = useState("")
    const [statesData, setStatesData] = useState([])
    const [bankData,setBanksData]=useState([])
    const userData = props?.userdetails
    const [userDetailsData,setUserDetailsData] = useState(userData)
    const [cityData, setCityData] = useState([])
    const [fromPage,setFromPage]=useState("")
    
    const [initialValues, setInitialValues] = useState({
        userId :userDetailsData?.id || '',
        firstName: userDetailsData?.first_name || '',
        middleName: userDetailsData?.middle_name || '',
        lastName: userDetailsData?.last_name || '',
        email: userDetailsData?.email || '',
        phoneNumber: userDetailsData?.phone_number || '',
        address1: userDetailsData?.address1 || '',
        address2: userDetailsData?.address2 || '',
        dematAccount: userDetailsData?.demat_account || '',
        state: userDetailsData?.state || '',
        city: userDetailsData?.city || '',
        pincode: userDetailsData?.post_code || '',
        cityName: userDetailsData?.city_name || '',
        stateName: userDetailsData?.state_name || '',
        bankId: userDetailsData?.bank_id !== 'null' && userDetailsData?.bank_id !== null  ? userDetailsData?.bank_id :'',
        bankName: userDetailsData?.bank_name !== 'null' && userDetailsData?.bank_name !== null ? userDetailsData?.bank_name : '',
        nameAsPerBankAccount:userDetailsData?.name_on_bank !== 'null' && userDetailsData?.name_on_bank !== null ? userDetailsData?.name_on_bank : '',
        accountNumber: userDetailsData?.bank_account_no !== 'null' && userDetailsData?.bank_account_no !== null ? userDetailsData?.bank_account_no :'',
        confirmAccountNumber: userDetailsData?.bank_account_no !== 'null' && userDetailsData?.bank_account_no !== null ? userDetailsData?.bank_account_no : '',
        ifscCode: userDetailsData?.bank_ifsc !== 'null' && userDetailsData?.bank_ifsc !== null ? userDetailsData?.bank_ifsc : '',
    });


//function call to close modal
    const handleCloseModal =  async () => {
        setStateId("")
        formik.resetForm();
        modalClose()
      }

//use effect funtion call to call intial apis
    useEffect(() => {
        callStateslistApi()
        callBankData()
    }, []);

    useEffect(() => {
        if (stateId !== "" || userDetailsData?.state !== "") {
            callCitylistApi()
        }

    }, [stateId]);

    //function to call list api
    const callStateslistApi = async () => {
        try{
            const res = await getStateList("state/1")
            if (res?.success) {
                setStatesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
    }

    //function call to call list of city api
    const callCitylistApi = async () => {
        try{
            const reqbody = {
                state_id: stateId || userDetailsData?.state
            }
            const res = await GetCityList(`city`,reqbody)
            if (res?.success) {
                const citiesWithOthers = [...res?.data, { id: 'others', name: 'Others' }];
                setCityData(citiesWithOthers)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        } 
    }

     //function to call list api
     const callBankData = async () => {
        try{
            const res = await getBankList("bank")
            if (res?.success) {
                setBanksData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
       
    }

    const {
        handleSubmit,
        setValue,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: {
            checkbox: false,
        },
    });

    //..............handle onchange of the form field......................................................//
    //function call to change first name
    const handleNameChange = event => {
        const newName = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            firstName: newName,
        }));
    };
//function call to change last name
    const handleLastNameChange = event => {
        const newName = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            lastName: newName,
        }));
    };
//function call to change email
    const handleEmailChange = event => {
        const newEmail = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            email: newEmail,
        }));
    };
//function call to change address field
    const handleAddress1Change = event => {
        const address1 = event;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            address1: address1,
        }));
    };
//function call to change bank select
    const handleBankChange = event => {
        const bank = event.target.value;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            bankId: bank?.id,
        }));

    };
//function call to change account number
    const handleChangeAccountNumber = event => {
        let accountNumber = event;

            // Update only the 'email' field in formik values
            formik.setValues(prevValues => ({
                ...prevValues,
                accountNumber: accountNumber,
            }));
        
    };
//function call to change confirm account number
    const  handleConfirmAccountNumber = event => {
        let confirmAccountNumber = event;

            // Update only the 'email' field in formik values
            formik.setValues(prevValues => ({
                ...prevValues,
                confirmAccountNumber: confirmAccountNumber,
            }));
        
    };
//function call to change ifsc code
    const handleIfscCode = event => {
        let ifscCode = event 

        if(ifscCode.startsWith(" ")  ){
            ifscCode = ""
        }else{
            ifscCode = event
        }

      
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            ifscCode: ifscCode,
        }));
    };
//function call to change name as per bank account
    const handleChangeNameAsBankAccount = event => {

        let  name = event;
        if(name.startsWith(" ")){
            name = ""
        }else{
            name = event
        }
        
        formik.setValues(prevValues => ({
            ...prevValues,
            nameAsPerBankAccount: name,
        }));

       
    };
//function call to change demat account
    const handleDematAccountChange = event => {
        let dematAccountId = event 

        if(dematAccountId.startsWith(" ")  ){
          dematAccountId = ""
        }else{
            dematAccountId = event
        }

      
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            dematAccount: dematAccountId,
        }));
    };
//function call to change state
    const handleStateChange = event => {
        const state = event.target.value;
        setStateId(state?.id)
        setCityData([])
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            state: state?.id,
            city: "",
            cityName : ""
        }));
    };
//function call to change city
    const handleCityChange = event => {
        const city = event.target.value;
        // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            city: city?.id,
        }));
    };
//function call to change pincode
    const handlePincodeChange = event => {
        const pincode = event;
        if(pincode.length <= 6)
        {
            // Update only the 'email' field in formik values
        formik.setValues(prevValues => ({
            ...prevValues,
            pincode: pincode,
        }));
        }
    };
//function call to change mobile number
    const handleNumberChange = event => {
        const number = event;
        //setStateId(event.target.value)
        formik.setValues(prevValues => ({
            ...prevValues,
            phoneNumber: number,
        }));
    };
  //function to validate form
    const validate = values => {
        const errors = {};
        // Validate email
        if (!values.firstName) {
            errors.firstName = 'First Name Required';
        } else if (!values.lastName) {
            errors.lastName = 'Last Name Required'
        }
        else if (!values.phoneNumber ) {
            errors.phoneNumber = 'Phone Number Required'
        }
        else if (!values.email) {
            errors.email = 'Email Required';
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
            errors.email = 'Invalid email address';
        } else if (!values.state) {
            errors.state = 'State Required';
        } else if (!values.city) {
            errors.city = 'City Required';
        } else if (!values.address1) {
            errors.address1 = 'Address 1 Required'
        }  else if (!values.pincode) {
            errors.pincode = 'Pincode Required'
        }else if (values.pincode.length < 6) {
            errors.pincode = 'Please enter valid 6 digit pincode'
        }
        else if (values.dematAccount.length > 1 && values.dematAccount.length < 16) {
            errors.dematAccount = "Invalid demat account number"
        }
        //  else if (!values.bankId) {
        //     errors.bankId = "Please Select the bank"
        // }
        // else if (!values.nameAsPerBankAccount) {
        //     errors.nameAsPerBankAccount = "Please enter name as per the bank records"
        // }
        else if (values.nameAsPerBankAccount !== "" && values.nameAsPerBankAccount.length < 3) {
            errors.nameAsPerBankAccount = "Please enter min 3 characters"
        }
        else if ((values.accountNumber.length < 9 || values.accountNumber.length > 18) && values.accountNumber !== "") {
            errors.accountNumber = "Please enter valid account number"
        }
        // else if (!values.confirmAccountNumber) {
        //     errors.confirmAccountNumber = "Please enter the above account number for confirmation"
        // }
        else if (values.confirmAccountNumber !== values.accountNumber) {
            errors.confirmAccountNumber = "Number does'nt matches the above account number"
        }
        // else if (!values.ifscCode) {
        //     errors.ifscCode = "Please enter the IFSC Code"
        // }
        else if  (values.ifscCode.length !== 11 && values.ifscCode !== "") {
            errors.ifscCode = "Invalid IFSC Code"
        }

        return errors;
    };
    //function to hit profile submit api 
    const handleProfileSubmit = async (values) => {
        const reqbody = {
               user_id:values.userId,
               first_name : values.firstName,
               middle_name : values.middleName,
               last_name : values.lastName,
               email : values.email,
               address1 : values.address1,
               demat_account:values.dematAccount,
               state : values.state,
               city : values.city,            
               bank_id : values.bankId !== '' ? values.bankId : null ,
               name_on_bank:values.nameAsPerBankAccount !== '' ? values.nameAsPerBankAccount : null,
               bank_account_no:values.accountNumber !== '' ? values.accountNumber : null,
               bank_ifsc:values.ifscCode !== '' ? values.ifscCode : null,
               post_code :  values.pincode ,
               phone_number: values.phoneNumber
         }
         setEmail(values.email)
         try{
            const res = await UpdateUserApi("user", reqbody);
        //     let obj = {
        //        first_name: values.firstName,
        //        last_Name: values.lastName,
        //        role: role,
        //        id: id
        //    }
        //    let userInfo = JSON.stringify(obj);
            if(res.success) {
               //  handleUSerDetailsApi()
                //   await storeData("userInfo", userInfo);
                modalClose()
                   showToast(1,"Profile updated successfully")
            }else{
               console.log("res",res?.errors)
              showToast(3,res?.errors[0]?.msg)
            }
         }catch(error){
            console.log("error",error)
         }
        
   }
   //function to call city api again
   const handleCityApi = () => {
    callCitylistApi()
    formik.setValues(prevValues => ({
        ...prevValues,
        city: "",
    }));
}
  //function to handle on click of space submit
  const handleKeyDown = (event) => {
    // Check if the pressed key is the space key and if the submit button is focused
    if (event.key === ' ' || event.key === 'Spacebar') {
      const submitButton = document.activeElement;
      if (submitButton && submitButton.type === 'submit') {
        // Prevent the default action (form submission) when the space key is pressed
        event.preventDefault();
      }
    }
  };

    const formik = useFormik({
        initialValues: initialValues,
        validate,
        enableReinitialize: true,
        onSubmit: values => {

            // Handle form submission
             handleProfileSubmit(values)
            // resetForm();
        },

    });

    const isFormFilled = () => {
      
        // Custom validation function to check if all required fields are filled
        return formik.values?.firstName !== '' && formik.values?.lastName !== '' && formik.values?.phoneNumber !== '' && formik.values?.email !== '' && formik.values?.address1 !== '' && formik.values.pincode !== '' && formik.values.state !== '' && ( formik.values.city !== "" || userDetailsData?.city_name !== "") 
    };

    return(
        <Modal show={modalOpen} onHide={handleCloseModal} centered size={"xl"} backdrop="static" >
        <Modal.Header style={{ backgroundColor: "#0A2FB6", color: "white" }} data-bs-theme="dark" closeButton>
            <h6 class="text-white fw-bold m-0 montserrat">{"Edit User Details"}</h6>
            
        </Modal.Header>
        <Modal.Body class=" p-4 pb-0">
       
        {/* <h2 class="fs-5 text-center mx-2"> {modalContent} </h2> */}
        <div class="full-height">
            <div className="d-flex justify-content-center">
            <form onKeyDown={handleKeyDown} onSubmit={formik.handleSubmit} autoComplete="off">
                <div class="d-flex flex-column col-12">
                    <div class="d-flex col-md-12 justify-content-center align-items-center">
                    </div>

                    <div class="d-flex col-md-12 justify-content-around my-2 flex-wrap">
                        <div class="col-md-3 mx-1 my-1">
                            <CustomTextField
                                control={control}
                                header={"First Name *"}
                                name="First Name"
                                size="small"
                                value={formik.values.firstName.trimStart()}
                                placeholder={"First Name"}
                                inputProps={{
                                    min: 1,
                                    maxLength: 30, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                helperText={formik.touched.firstName ? formik.errors.firstName : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^A-Za-z]/g, "");
                                    handleNameChange(result)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1 my-1">
                            <CustomTextField
                                control={control}
                                header={"Last Name *"}
                                name="LastName"
                                size="small"
                                value={formik.values.lastName.trimStart()}
                                placeholder={"Last Name"}
                                inputProps={{
                                    min: 1,
                                    maxLength: 30, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                helperText={formik.touched.lastName ? formik.errors.lastName : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[0-9]/g, "")
                                    // setMobileNumber(result);
                                    handleLastNameChange(result)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                                    <CustomTextField
                                        control={control}
                                        header={"Phone number *"}
                                        type={"tel"}
                                        name="Phone number"
                                        size="small"
                                        value={formik.values.phoneNumber.trimStart()}
                                        placeholder={"Phone number"}
                                        inputProps={{
                                            min: 10,
                                            maxLength: 10, style: {
                                                height: "28px",
                                            }
                                        }}
                                        error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                                        helperText={formik.touched.phoneNumber ? formik.errors.phoneNumber : ''}
                                        InputProps={{ sx: { borderRadius: "12px" } }}
                                        onChange={(e) => {
                                            const result = e.replace(/[^0-9]/g, '');
                                            // setMobileNumber(result);
                                            handleNumberChange(result)
                                        }}
                                    />
                                </div>
                        <div class="col-md-3 mx-1 my-1">
                            <CustomTextField
                                control={control}
                                header={"Email *"}
                                name="email"
                                size="small"
                                value={formik.values.email.trimStart() }
                                placeholder={"Email"}
                                inputProps={{
                                    min: 3,
                                    maxLength: 50, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.email && Boolean(formik.errors.email)}
                                helperText={formik.touched.email ? formik.errors.email : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    handleEmailChange(e)
                                }}
                            />
                        </div>

                        <div class="col-md-3 mx-1 my-1">
                            <div class="d-flex ">
                                <label class="fw-normal">
                                    State *
                                </label>
                            </div>
                            <CustomDropdown data={statesData}
                                onChange={(e) => {
                                    handleStateChange(e)
                                }}
                                value={formik.values.state }
                                defaultValue={userDetailsData?.state_name}
                                error={formik.touched.state && Boolean(formik.errors.state)}
                                helperText={formik.touched.state ? formik.errors.state : ''}
                                height={"44px"}
                                name="state"
                            />
                        </div>
                        <div class="col-md-3 mx-1 my-1 ">
                            <div class="d-flex ">
                                <label class="fw-normal">
                                    City *
                                </label>
                            </div>
                            <CustomDropdown data={cityData}
                                onChange={(e) => {
                                    handleCityChange(e)
                                }}
                                value={formik.values.city}
                                defaultValue={userDetailsData?.city_name}
                                error={formik.touched.city && Boolean(formik.errors.city)}
                                helperText={formik.touched.city ? formik.errors.city : ''}
                                height={"44px"}
                                callApi={handleCityApi}
                                stateId={stateId}
                                name="city"
                            />
                        </div>

                        <div class="col-md-3 mx-1 my-1 ">
                            <CustomTextField
                                control={control}
                                header={"Address *"}
                                name="address1"
                                size="small"
                                value={formik.values.address1.trimStart() }
                                placeholder={"Door no., Floor, Apartment,"}
                                inputProps={{
                                    min: 3,
                                    maxLength: 250,
                                    style: {
                                        height: "28px",
                                    }
                                }}
                                multiline={true}
                                rows={3}
                                error={formik.touched.address1 && Boolean(formik.errors.address1)}
                                helperText={formik.touched.address1 ? formik.errors.address1 : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/\D/g, "");
                                    // setMobileNumber(result);
                                    handleAddress1Change(e)
                                }}
                            />
                        </div>
                        <div class="col-md-3  my-1">
                            <CustomTextField
                                control={control}
                                header={"Pincode *"}
                                type={""}
                                name="pincode"
                                size="small"
                                value={formik.values.pincode.trimStart() }
                                placeholder={"Pincode"}
                                inputProps={{
                                    min: 6,
                                    maxLength: 6, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                                helperText={formik.touched.pincode ? formik.errors.pincode : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/\D/g, "");
                                    // setMobileNumber(result);
                                    handlePincodeChange(result)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Demat Account Number"}
                                name="Demat Account "
                                size="small"
                                value={formik.values.dematAccount.trimStart() }
                                placeholder={"Demat Account Number"}
                                multiline={false}
                                //rows={3}
                                inputProps={{
                                    min: 16,
                                    maxLength: 16,
                                    style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.dematAccount && Boolean(formik.errors.dematAccount)}
                                helperText={formik.touched.dematAccount ? formik.errors.dematAccount : ''}
                                InputProps={{ sx: { borderRadius: "12px" }  
                                }}
                                onChange={(e) => {
                                    const result = e.replace(" ", "");
                                    // setMobileNumber(result);
                                    handleDematAccountChange(result.toUpperCase())
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1 my-1">
                            <div class="d-flex ">
                                <label class="fw-normal">
                                    Select Bank 
                                </label>
                            </div>
                            <CustomDropdown data={bankData}
                                onChange={(e) => {
                                    handleBankChange(e)
                                }}
                                error={formik.touched.bankId && Boolean(formik.errors.bankId)}
                                helperText={formik.touched.bankId ? formik.errors.bankId : ''}
                                value={formik.values.bankId}
                                defaultValue={formik.values.bankName}
                                name="bankName"
                                fromName="bankName"
                                height={"44px"}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Name as per the bank records"}
                                name="nameAsPerBankAccount"
                                size="small"
                                value={formik.values.nameAsPerBankAccount.trimStart()}
                                placeholder={"Name as per the bank records"}
                                inputProps={{
                                    min: 1,
                                    maxLength: 30,
                                    style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.nameAsPerBankAccount && Boolean(formik.errors.nameAsPerBankAccount)}
                                helperText={formik.touched.nameAsPerBankAccount ? formik.errors.nameAsPerBankAccount : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^A-Za-z]/g, "");
                                    handleChangeNameAsBankAccount(e)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Account Number "}
                                type={"tel"}
                                name="Account Number"
                                size="small"
                                value={formik.values.accountNumber.trimStart()}
                                placeholder={"Account Number"}
                                inputProps={{
                                    min: 9,
                                    maxLength: 18, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.accountNumber && Boolean(formik.errors.accountNumber)}
                                helperText={formik.touched.accountNumber ? formik.errors.accountNumber : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^0-9]/g, '');
                                    // setMobileNumber(result);
                                    handleChangeAccountNumber(result)
                                }}
                            />
                        </div>
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"Confirm Account Number "}
                                type={"tel"}
                                name="Confrim Account Number"
                                size="small"
                                value={formik.values.confirmAccountNumber.trimStart()}
                                placeholder={"Confrim Account Number"}
                                inputProps={{
                                    min: 9,
                                    maxLength: 18, style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.confirmAccountNumber && Boolean(formik.errors.confirmAccountNumber)}
                                helperText={formik.touched.confirmAccountNumber ? formik.errors.confirmAccountNumber : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(/[^0-9]/g, '');
                                    // setMobileNumber(result);
                                    handleConfirmAccountNumber(result)
                                }}
                            />
                        </div>
                        
                        <div class="col-md-3 mx-1  my-1">
                            <CustomTextField
                                control={control}
                                header={"IFSC Code"}
                                name="IFSC Code"
                                size="small"
                                value={formik.values.ifscCode.trimStart()}
                                placeholder={"IFSC Code"}
                                multiline={false}
                                //rows={3}
                                inputProps={{
                                    min: 11,
                                    maxLength: 11,
                                    style: {
                                        height: "28px",
                                    }
                                }}
                                error={formik.touched.ifscCode && Boolean(formik.errors.ifscCode)}
                                helperText={formik.touched.ifscCode ? formik.errors.ifscCode : ''}
                                InputProps={{ sx: { borderRadius: "12px" } }}
                                onChange={(e) => {
                                    const result = e.replace(" ", "");
                                    // setMobileNumber(result);
                                    handleIfscCode(result.toUpperCase())
                                }}
                            />
                        </div>
                    </div>
                    <div class="align-self-center text-center">
                        <button type="submit" variant="contained" class={isFormFilled() ? "primaryButton" : "disabledButton"} >
                            Update
                        </button>
                    </div>
                </div>
            </form>
        </div>  
            </div>
     
        </Modal.Body>
        <Modal.Footer class="d-flex justify-content-around ">
<div class="d-flex justify-content-around w-50 mb-1 mt-2">

</div>
</Modal.Footer>
    </Modal>
    )
}

export default EditUserDetails